export default {
  token: state => state.token,
  appid: state => state.appid,
  status: state => state.status,
  init: state => state.init,
  sessionId: state => state.sessionId,
  theme: state => state.theme,
  isHorizontal: state => state.isHorizontal,
  themeConfig: state => state.themeConfig,
  isInit: state => state.isInit,
  receivedGiftList: state => state.receivedGiftList,
  unreceivedGiftList: state => state.unreceivedGiftList,
  noticeList: state => state.noticeList,
  cusContent: state => state.cusContent,
  giftStatus: state => state.giftStatus,
  noticeStatus: state => state.noticeStatus,
  cusStatus: state => state.cusStatus,
  idfa: state => state.idfa,
  gameData: state => state.gameData
}
